<template>
  <a @click="onexport()" class="button is-primary tailleBtn">
    <b-icon class="icon_collapse"
      icon="file-excel">
    </b-icon>
    <span>Exporter</span>
  </a>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    dataExport: Object,
  },
  data: () => ({
    datas: {},
  }),
  computed: {
    show() {
      if (Array.isArray(this.dataExport.data) && this.dataExport.data.length) {
        return true;
      }
      return false;
    },
    fileName() {
      if (this.dataExport.libelleReseau) return this.dataExport.libelleReseau + '.xlsx';
      return '';
    },
    planningAnnuelData() {
      const tableauPlanning = this.dataExport.data.flat();
      tableauPlanning.forEach((el) => {
        if (el.class === 'color2') {
          el.couleur = 'Bloqué';
        } else if (el.class === 'color3') {
          el.couleur = 'Bloqué partiellement';
        } else if (el.class === 'color4') {
          el.couleur = 'Optionné';
        } else {
          el.couleur = 'Libre';
        }
        el.nomReseau = this.dataExport.libelleReseau;
      });
      const tableauReseau = tableauPlanning.map(el => ({
        'Nom du réseau': el.nomReseau,
        'Numéro semaine': el.semaine,
        'Date de départ': el.dateStart.format('L'),
        Annonceur: el.annonceurComplet,
        Couleur: el.couleur,
      }));
      return tableauReseau;
    },
  },
  methods: {
    onexport() {
      if (this.planningAnnuelData.length) {
        const listeWS = XLSX.utils.json_to_sheet(this.planningAnnuelData);

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, listeWS, this.fileName.split('.')[0]);

        XLSX.writeFile(wb, this.fileName);
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/recherche/exportExcel.vue